import {
  createContext,
  useContext,
} from 'react'

const LocationContext = createContext({})


export default LocationContext

export function useLocation() {
  return useContext(LocationContext)
}
